
import api from "@/network";

export default {
    state: {
        designSettings: null,
    },

    getters: {
        designSettings(state) {
            return state.designSettings;
        },
    },

    actions: {
        // Получение настроек дизайна
        async fetchDesignSettings({ commit }) {
            try {
                const response = await api.get(`admin/design`);
                commit('updateDesignSettings', response?.data?.data);
                return response?.data?.data;
            } catch (error) {
                console.error('Ошибка при загрузке настроек дизайна:', error);
                return null;
            }
        },

        // Обновление настроек цветов
        async updateDesignSettings({ commit, state }, payload = {}) {
            try {
                const response = await api.put(`admin/design`, {
                    buttonColor: payload.buttonColor,
                    fontColor: payload.fontColor,
                    enabled: payload.enabled !== undefined ? payload.enabled : true
                });

                commit('updateDesignSettings', {
                    ...state.designSettings,
                    buttonColor: payload.buttonColor,
                    fontColor: payload.fontColor,
                    enabled: payload.enabled !== undefined ? payload.enabled : true
                });

                return response?.data?.data;
            } catch (error) {
                console.error('Ошибка при обновлении настроек дизайна:', error);
                throw error;
            }
        },

        // Загрузка логотипа
        async uploadLogo({ commit, state }, payload = {}) {
            try {
                const formData = new FormData();
                formData.append('logo', payload.file);

                const response = await api.post(`admin/design/logo`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                commit('updateDesignSettings', {
                    ...state.designSettings,
                    logo: response?.data?.data?.logo
                });

                return response?.data?.data;
            } catch (error) {
                console.error('Ошибка при загрузке логотипа:', error);
                throw error;
            }
        },

        // Включение/отключение пользовательского дизайна
        async toggleDesignStatus({ commit, state }, payload = {}) {
            try {
                const response = await api.put(`admin/design/status`, {
                    enabled: payload.enabled
                });

                commit('updateDesignSettings', {
                    ...state.designSettings,
                    enabled: payload.enabled
                });

                return response?.data?.data;
            } catch (error) {
                console.error('Ошибка при изменении статуса дизайна:', error);
                throw error;
            }
        }
    },

    mutations: {
        updateDesignSettings(state, designSettings) {
            state.designSettings = designSettings;
        },
    },
}